module.exports = __webpack_public_path__ + "img/papua-new-guinea-logo-icon.b6213559.png";